
/*
export function someGetter(state) {
}
*/
